import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLinkActive, RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';

@Component({
    selector: 'sb-pills',
    template: `
        <nav role="tablist" [class]="'sb-' + type">
            <div
                *ngFor="let pill of pills"
                routerLinkActive
                #rla="routerLinkActive"
                [routerLinkActiveOptions]="routerLinkActiveOptions"
            >
                <a
                    [routerLink]="pill.disabled ? null : pill.path"
                    [attr.aria-selected]="rla?.isActive || null"
                    [class.text-muted]="pill.disabled || !pill?.path"
                    [style.position]="
                        pill.disabled || !pill?.path ? 'initial' : undefined
                    "
                    role="tab"
                    [matTooltip]="
                        pill.status === 'coming soon' ? 'Coming soon!' : undefined
                    "
                >
                    {{ pill.label }}
                </a>
            </div>
        </nav>
    `,
    standalone: true,
    imports: [CommonModule, RouterLink, RouterLinkActive, MatTooltipModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SbPillsComponent {
    get routerLinkActiveOptions(): RouterLinkActive['routerLinkActiveOptions'] {
        return this._routerLinkActiveOptions;
    }

    @Input() set routerLinkActiveOptions(
        value: RouterLinkActive['routerLinkActiveOptions']
    ) {
        this._routerLinkActiveOptions = value;
    }
    get pills(): Pills {
        return this._pills;
    }

    @Input() set pills(value: Pills) {
        this._pills = value;
    }
    private _pills: Pills;

    get type() {
        return this._type;
    }

    @Input() set type(type) {
        this._type = type;
    }

    private _type: 'pills' | 'tabs' = 'pills';

    private _routerLinkActiveOptions: RouterLinkActive['routerLinkActiveOptions'] = {
        exact: true
    };
}

export type Pills = Array<Pill>;

interface Pill {
    path: string;
    label: string;
}
